import Cookie from 'js-cookie';
import { ResponsiveUtilities, SiteUtilities } from './utils';

/**
 * This function stores the state of the Logos and returns methods which are used to manipulate
 * logo theme in hamburger menus, sticky nav and during breakpoint changes
 */
const logoThemeHandlers = (() => {
  const $logo = jQuery('.nav-primary .logo').first();
  const originalTheme = $logo.attr('src');
  return {
    // This method resets logo to default theme
    reset: () => {
      if (originalTheme) {
        $logo.attr('src', originalTheme);
      }
    },
    toggleLogoTheme: (sticky = false) => {
      if (!/-white\./.test(originalTheme) || sticky) { // If Logo is white, ignore toggling in the hamburger menu
        const logoSrc = $logo.attr('src');
        if (logoSrc) {
          const currentTheme = logoSrc.match(/-(black|white)\.(png|svg)/);
          if (currentTheme) {
            const newTheme = sticky
              ? 'black' : currentTheme[1] === 'white'
                ? 'black' : 'white';
            $logo.attr('src', logoSrc.replace(currentTheme[1], newTheme));
          }
        }
      }
    }
  };
})();

/*
 * burgerIconHandler toggles classes to activate the navigation in
 * non-desktop views. The function logic has been separated from the
 * event listener to provide for cases where the icon needs to be
 * triggered programmatically
 */
const burgerIconHandler = () => {
  logoThemeHandlers.toggleLogoTheme();
  if (jQuery('body').hasClass('nav-active')) {
    jQuery('.nav-primary-opened .nav-label, .nav-primary-opened .nav-company-menu .nav-company-logo a, .lang-selector select, .nav-primary-opened .nav-sub-item .nav-sub-label').attr('tabindex', -1);
    jQuery('.nav-burger').attr('aria-expanded', 'false');
    jQuery('.nav-primary').removeClass('nav-primary-opened');
    jQuery('.nav-primary .sub-menu-opened').removeClass('sub-menu-opened');
    jQuery('body').removeClass('nav-active');
  } else {
    jQuery('.nav-primary').addClass('nav-primary-opened');
    jQuery('.nav-burger').attr('aria-expanded', 'true');
    jQuery('.nav-primary-opened .nav-label, .nav-primary-opened .nav-company-menu .nav-company-logo a, .lang-selector select').attr('tabindex', 0);
    jQuery('body').addClass('nav-active');
    if (jQuery('.nav-main-menu .nav-logo-tagline').length > 0) {
      // triggerSubMenu.call(jQuery('.nav-main-menu .nav-logo-tagline').parents('.nav-main-item')[0]);
    }
  }
};

/*
 * triggerSubMenu toggles the sub-menus in different ways
 * based on the width of the window and breakpoint definitions.
 */
const triggerSubMenu = function () {
  if (jQuery(this).hasClass('sub-menu-opened')) {
    // setting tabindex to -1 for all the menus in navigation so that focus should not go inside until and unless user press enters to open the nav menu
    jQuery('.sub-menu-opened .nav-sub-menu .nav-sub-item .nav-sub-label, .sub-menu-opened .nav-sub-menu .bottom-pane a, .sub-menu-opened .nav-main-item-list a, .sub-menu-opened .nav-sub-item-link a, .sub-menu-opened .nav-sub-menu-with-parts .nav-sub-item .nav-sub-label, .sub-menu-opened .navigation-language-selector .nav-sub-label').attr('tabindex', -1);
    jQuery('.sub-menu-opened a.nav-label,.sub-menu-opened a.fw-flag-globe, .sub-menu-opened a.nav-super-label').attr('aria-expanded', 'false');
    jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
  } else {
    jQuery('.sub-menu-opened .nav-sub-menu .nav-sub-item .nav-sub-label, .sub-menu-opened .nav-sub-menu .bottom-pane a, .sub-menu-opened .nav-main-item-list a, .sub-menu-opened .nav-sub-item-link a, .sub-menu-opened .nav-sub-menu-with-parts .nav-sub-item .nav-sub-label, .sub-menu-opened .navigation-language-selector .nav-sub-label').attr('tabindex', -1);
    jQuery('.sub-menu-opened a.nav-label,.sub-menu-opened a.fw-flag-globe, .sub-menu-opened a.nav-super-label').attr('aria-expanded', 'false');
    jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
    jQuery(this).addClass('sub-menu-opened');
    jQuery('.sub-menu-opened .nav-label,.sub-menu-opened .fw-flag-globe, .sub-menu-opened .nav-super-label').attr('aria-expanded', 'true');
    // setting tabindex to 0 for all the menu which is opened to allow focus
    jQuery('.sub-menu-opened .nav-sub-menu .nav-sub-label, .sub-menu-opened .nav-sub-menu .bottom-pane a, .sub-menu-opened .nav-main-item-list a, .sub-menu-opened .nav-sub-item-link a, .sub-menu-opened .nav-sub-menu-with-parts .nav-sub-item .nav-sub-label, .sub-menu-opened .navigation-language-selector .nav-sub-label').attr('tabindex', 0);
  }
};

// headerHeight is used to determine when to trigger sticky
var getHeaderHeight = (header) => {
  const headerRect = header.getBoundingClientRect();
  return headerRect.bottom - headerRect.top;
};

const addscrollToLanguagePicker = () => {
  const height = $(window).height();
  const $languageSelector = $('.navigation-language-selector') || null;
  if (!$languageSelector) return;
  $($languageSelector).removeClass('language-selector-card-scrollable');
  if (height && height < 800) {
    if (!$($languageSelector).hasClass('language-selector-card-scrollable')) {
      $($languageSelector).addClass('language-selector-card-scrollable');
    }
  }
};

/*
 * navLoader initiates all of the interactions listeners and handlers
 * for the navigation.
 */
const navLoader = () => {
  const inPageScrollPresent = jQuery('.inpage-scroll').length > 0;
  // Burger icon listener
  jQuery('.nav-burger').on('click', (e) => {
    ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], burgerIconHandler, this, e);
  });

  // Sub-menu listener
  // NOTE: We haven't used an arrow function for the event handler since
  // we need access to the 'this' keyword within this handler.
  jQuery('.has-sub-menu').on('click', function (e) {
    e.stopPropagation();
    if (jQuery(e.target).parents('.nav-sub-menu').length === 0) {
      triggerSubMenu.call(this);
    }
  });

  addscrollToLanguagePicker();

  // Slide the active menu line
  var slideMenuLock = false;

  function getElementContentWidth (element) {
    var styles = window.getComputedStyle(element);
    var padding = parseFloat(styles.paddingLeft) + parseFloat(styles.paddingRight);
    return element.clientWidth - padding;
  }

  const slideMenuLine = function ($menuItem) {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      if (!$menuItem.length) {
        return;
      }

      const leftPosition = $menuItem.position().left;
      const lineWidth = getElementContentWidth($menuItem[0]);

      if (!slideMenuLock) {
        jQuery('.menu-line').css({
          width: lineWidth,
          left: leftPosition,
          opacity: 1
        });
      }
    });
  };

  // Initialize active menuitem
  const initMenuItemActive = () => {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      const $activeMenuItem = jQuery('.nav-secondary').find('.active');

      if ($activeMenuItem.length !== 0) {
        slideMenuLine($activeMenuItem.find('a'));
      }
    });
  };

  const menuLineFadeOut = () => {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      jQuery('.menu-line').css({
        opacity: 0
      });
    });
  };

  const embedGoToAccount = () => {
    const goToDashboardLabel = ($('.go-to-dashboard').val() || '').trim();
    if (!goToDashboardLabel) return;
    const prod = $('body').data('product-name');

    const setNavBtn = (url) => {
      const $nav = $('.nav-primary');
      $nav.find('.go-to-dashboard').parent('.nav-main-item-button').find('.button').attr('href', url).text(goToDashboardLabel);
      $nav.find('[data-nav-login="yes"]').parent('.nav-main-item').hide();
      // Go To Account in Super Nav
      const $navSuper = $('.nav-super');
      $navSuper.find('.go-to-dashboard').parent('.nav-button').find('.button').attr('href', url).text(goToDashboardLabel);
      $navSuper.find('[data-nav-login="yes"]').parent('.nav-super-item').hide();
    };

    const getLastAccessedAccountUrl = (prod) => {
      try {
        let lastAccessedAccounts;
        if (prod === 'fservice') {
          lastAccessedAccounts = Cookie.get('last_accessed_fs_accounts') || null;
          return (lastAccessedAccounts && JSON.parse(atob(lastAccessedAccounts))[0]) || null;
        }
        lastAccessedAccounts = Cookie.get('last_accessed_accounts') || null;
        if (!lastAccessedAccounts) return;
        lastAccessedAccounts = JSON.parse(atob(lastAccessedAccounts));
        const prodKey = {
          fdesk: 'freshdesk',
          fchat: 'crm_chat',
          fsales: 'crm_sales',
          fmarketer: 'crm_marketer',
          fwcrm: 'fw_crm',
          fcaller: 'crm_caller',
          fwcssuite: 'cxsuite'
        };
        const accountUrls = lastAccessedAccounts && lastAccessedAccounts[prodKey[prod]];
        const accountUrl = (accountUrls && accountUrls[0]) || null;
        return accountUrl;
      } catch (e) {
      }
    };

    let productUrl = getLastAccessedAccountUrl(prod);
    if (!productUrl) return;

    if (!(productUrl.includes('https://') || productUrl.includes('http://'))) {
      productUrl = `https://${productUrl}`;
    }
    if (!productUrl.endsWith('/')) productUrl += '/';

    switch (prod) {
      case 'fdesk': {
        try {
          if (new RegExp('.com/$').test(productUrl)) {
            productUrl = productUrl + 'a/?cname_redirect=true';
          }

          setNavBtn(productUrl);
        } catch (e) {
        }
        break;
      }
      case 'fchat':
      case 'fsales':
      case 'fmarketer':
      case 'fwcrm':
      case 'fcaller':
      case 'fwcssuite':
      case 'fservice':
        setNavBtn(productUrl);
        break;
    }
  };

  jQuery(window).on('load', function (e) {
    initMenuItemActive();
  });

  jQuery('.nav-secondary .nav-sub-item a').hover(function (e) {
    const $element = jQuery(this);
    slideMenuLine($element);
  }, function () {
    if (!jQuery(this).parent().hasClass('active')) {
      menuLineFadeOut();
    }
    initMenuItemActive();
  });

  // Listener to dismiss sub-menus locked in the open state when
  // hovering over another menu item which contains a sub-menu
  jQuery('.has-sub-menu:not(.nav-secondary-item)').on('mouseenter', function (e) {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      // ensure that the opened state is not removed if the users
      // hover again over the sub-menu that they just opened
      if (!jQuery(this).hasClass('sub-menu-opened')) {
        jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
      }
    }, this, e);
  });

  // Language selector listener
  jQuery('.lang-options').on('change', () => {
    window.location.assign(jQuery('.lang-options :selected').attr('data-link'));
  });

  // Window resize listener for resetting nav during resize
  jQuery(window).on('breakpointChanged', () => {
    logoThemeHandlers.reset();
    jQuery('.nav-burger').attr('aria-expanded', 'false');
    jQuery('.nav-primary-opened').removeClass('nav-primary-opened');
    jQuery('body').removeClass('nav-active');
    jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
    jQuery('.nav-secondary-buckets > .nav-sub-label').html('');
    jQuery('.nav-secondary-buckets').removeClass('suppressed');
  });

  /*
   * On pages with a secondary nav bar, only the secondary bar is
   * shown in the sticky state. The primary nav bar is shown only
   * when the user is scrolling up and hidden when the user starts
   * scrolling down. currentScrollPosition and lastScrollPosition
   * are used to determine scroll direction
   */
  var currentScrollPosition = 0;
  var lastScrollPosition = 0;

  // scrollLock is used to achieve a debounce on the scroll listener
  var scrollLock = false;

  /*
   * stickyLock is used to disable the selective showing of the primary
   * nav bar (as explained above) when an animated scrolls are triggered
   * programmatically - i.e. the user is not naturally scrolling, but is
   * actually being taken to an anchor with some animation.
   */
  var stickyLock = false;
  const navElement = jQuery('nav');
  const isSecondaryNavPresent = jQuery('nav.has-secondary').length > 0 || false;
  var isStickyTablePresent = jQuery('#pricing-compare:not(.addon-pricing-header)').length > 0 || (jQuery('.detail-comparison-table').hasClass('has-sticky-header'));
  if (isSecondaryNavPresent) {
    isStickyTablePresent = false;
  }
  // Compute headerHeight initially
  var headerHeight = getHeaderHeight(navElement[0]);

  // get first fold height. if first fold is not present, set to 0.
  let firstFoldHeight = jQuery('.first-fold').first().outerHeight();
  firstFoldHeight = typeof firstFoldHeight === 'undefined' ? 0 : firstFoldHeight;

  // set triggering point to the lesser of headerHeight * 4 or firstfoldheight
  // NOTE: in latter case, we set trigger height to first fold height - headerheight
  //       to ensure that the sticky header appears right before the second fold when
  //       scrolling.
  let stickyTriggerHeight = (headerHeight * 4 <= firstFoldHeight && firstFoldHeight !== 0) ? headerHeight : firstFoldHeight - headerHeight;

  // Update headerHeight when the window is resized
  jQuery(window).on('resize', () => {
    headerHeight = getHeaderHeight(navElement[0]);
    firstFoldHeight = jQuery('.first-fold').first().outerHeight();
    firstFoldHeight = typeof firstFoldHeight === 'undefined' ? 0 : firstFoldHeight;
    stickyTriggerHeight = (headerHeight * 4 <= firstFoldHeight && firstFoldHeight !== 0) ? headerHeight : firstFoldHeight - headerHeight;
  });

  jQuery('.scroll-link').click(function () {
    jQuery('.scroll-link').removeClass('active');
    jQuery(this).addClass('active');
  });
  // Scrolling Nav Listeners
  let navHeight = 0;

  jQuery('[data-scroll-link]').on('click', function (e) {
    e.preventDefault();
    // scrolling navigation listeners
    navHeight = jQuery('nav').height();
    if (jQuery(window).innerWidth() < 960) {
      if (jQuery('nav > div').hasClass('nav-secondary-wrapper')) {
        navHeight -= jQuery('.nav-primary-wrapper').height();
      }
    }
    if (inPageScrollPresent) {
      navHeight += jQuery('.inpage-scroll').height();
    }
    stickyLock = true;
    slideMenuLock = true;
    // time-out the scroll to allow the sub-menu to get dismissed (looks cleaner
    // when sequenced like this)
    const scrollToTarget = jQuery(this).attr('data-scroll-link');
    window.setTimeout(() => {
      jQuery('html, body').stop().animate({
        scrollTop: (jQuery("*[data-scroll-target='" + scrollToTarget + "']").offset() || { top: NaN }).top - navHeight
      }, 300, 'swing', () => {
        // time out the stickyLock release so that the sticky is not
        // removed when scrolling upwards to the first glossary section
        window.setTimeout(() => {
          stickyLock = false;
          slideMenuLock = false;
          // menuline init after scroll target reaches.
          const activeListItem = jQuery('.nav-secondary-wrapper .nav-sub-menu li');
          if (activeListItem.hasClass('active')) {
            slideMenuLine(jQuery(this));
          }
        }, 100);
      });
    }, 150);

    jQuery('html, body').animate({
      scrollTop: (jQuery("*[data-scroll-target='" + scrollToTarget + "']").offset() || { top: NaN }).top - navHeight
    }, 500);

    if (jQuery('.has-sub-menu').hasClass('sub-menu-opened')) {
      jQuery('.sub-menu-opened .nav-label').attr('aria-expanded', 'false');
      jQuery('.has-sub-menu').removeClass('sub-menu-opened');
    }

    if (jQuery('.nav-primary').hasClass('nav-primary-opened')) {
      jQuery('.nav-burger').click();
    }
  });

  jQuery('.scrollActive .scroll-anchor').on('click', function (e) {
    slideMenuLock = false;
  });

  // Feature Glossary Secondary Nav Listeners
  if (jQuery('.nav-secondary').length > 0) {
    jQuery('.bucket-link').on('click', function (e) {
      e.preventDefault();
      let target = 0;

      if (jQuery('nav').hasClass('nav-sticky')) {
        target = jQuery(jQuery(this).children('.nav-sub-label')[0].getAttribute('href')).offset().top;
      } else {
        target = jQuery(jQuery(this).children('.nav-sub-label')[0].getAttribute('href')).offset().top + jQuery('nav').outerHeight();
      }

      let offset = 0;
      if (jQuery('nav').hasClass('has-secondary')) {
        offset = jQuery('.nav-secondary').outerHeight() + (ResponsiveUtilities.getDeviceType() === 'desktop' ? jQuery('.nav-primary').outerHeight() : 0);
      } else {
        offset = jQuery('.nav-primary').outerHeight();
      }

      stickyLock = true;
      slideMenuLock = true;
      const scrollTarget = target - offset;
      triggerSubMenu.call(jQuery('.nav-secondary-wrapper .sub-menu-opened')[0]);

      // time-out the scroll to allow the sub-menu to get dismissed (looks cleaner
      // when sequenced like this)
      window.setTimeout(() => {
        jQuery('html, body').stop().animate({
          scrollTop: scrollTarget
        }, 300, 'swing', () => {
          // time out the stickyLock release so that the sticky is not
          // removed when scrolling upwards to the first glossary section
          window.setTimeout(() => {
            stickyLock = false;
            slideMenuLock = false;
          }, 100);
        });
      }, 150);
    });

    const updateSecondaryNavMobile = (label) => {
      jQuery('.nav-secondary-buckets').addClass('suppressed');
      jQuery('.nav-secondary-buckets > .nav-sub-label').html(label);
    };

    const updateSecondaryNavMobileDesktop = (id) => {
      if (inPageScrollPresent) {
        id = id.replace('#', '');
      }
      if (id && !jQuery('.nav-sub-label[data-scroll-link="' + id + '"]').parent('.nav-sub-item').hasClass('active')) {
        jQuery('.nav-sub-item.active').removeClass('active');
        jQuery('.nav-sub-label[data-scroll-link="' + id + '"]').parent('.nav-sub-item').addClass('active');
        slideMenuLine(jQuery('.nav-sub-label[data-scroll-link="' + id + '"]'));
      }
    };

    jQuery('section').on('checkSecondaryNav', (e) => {
      const bounds = e.target.getBoundingClientRect();

      if (!inPageScrollPresent) {
        ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], function () {
          if (bounds.top >= -50 && bounds.top < 250) {
            const navMobileId = jQuery(e.target).attr('data-scroll-target');
            if (!navMobileId || navMobileId === '') {
              return;
            }
            updateSecondaryNavMobile(jQuery('[ data-scroll-link = "' + navMobileId + '"]').html());
          } else if (bounds.top > 250 && bounds.top < jQuery(window).innerHeight()) {
            const previousSectionBucket = jQuery(e.target).prev('section');
            if (previousSectionBucket.length > 0 && previousSectionBucket.attr('data-scroll-target')) {
              const navMobileId = previousSectionBucket.attr('data-scroll-target');
              if (!navMobileId || navMobileId === '') {
                return;
              }
              updateSecondaryNavMobile(jQuery('[ data-scroll-link = "' + navMobileId + '"]').html());
            }
          }
        }, this);
      } else {
        ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], function () {
          if ((bounds.top > 300 - bounds.height) && (bounds.top < 300) && !e.target.classList.contains('inpage-scroll')) {
            let navMobileId = jQuery(e.target).attr('data-scroll-target');
            if (navMobileId) {
              navMobileId = navMobileId.replace('#', '');
            }
            if (!navMobileId || navMobileId === '') {
              return;
            }
            updateSecondaryNavMobile(jQuery('[ data-scroll-link = "' + navMobileId + '"]').html());
          }
        }, this);
      }

      ResponsiveUtilities.onDeviceType('desktop', function () {
        if (bounds.top >= -100 && bounds.top < 150) {
          const id = jQuery(e.target).attr('data-scroll-target');
          if (!id || id === '') {
            return;
          }
          updateSecondaryNavMobileDesktop(id);
        } else if (bounds.top > 150 && bounds.top < jQuery(window).innerHeight() && jQuery(e.target).prev('section').length !== 0) {
          const previousSectionBucket = jQuery(e.target).prev('section');
          if (previousSectionBucket.length > 0 && previousSectionBucket.attr('data-scroll-target')) {
            const id = previousSectionBucket.attr('data-scroll-target');
            updateSecondaryNavMobileDesktop(id);
          }
        }
      }, this);
    });

    /*
     * this listener ensures that the last bucket's title is highlighted
     * in the secondary nav when the user scrolls till the end of the page
     * in cases where the bucket section's height is much lesser than the
     * window's height (i.e. it will never satisfy the condition in the
     * secondary nav listener)
     */
    jQuery('section').last().on('checkSecondaryNav', () => {
      if (jQuery('body').outerHeight() - jQuery(window).scrollTop() === jQuery(window).innerHeight()) {
        ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], function () {
          const navMobileId = jQuery(this).attr('data-scroll-target');
          if (!navMobileId || navMobileId === '') {
            return;
          }
          updateSecondaryNavMobile(jQuery('[ data-scroll-link = "' + navMobileId + '"]').html());
        }, this);

        ResponsiveUtilities.onDeviceType('desktop', function () {
          var id = jQuery('section').last().attr('data-scroll-target');
          updateSecondaryNavMobileDesktop(id);
        }, this);
      }
    });

    jQuery(window).on('scroll', SiteUtilities.debounce(200, function (e) {
      if ((navElement.hasClass('nav-sticky') && navElement.hasClass('has-secondary')) || inPageScrollPresent) {
        jQuery('section').trigger('checkSecondaryNav');
      }
    }));
  }

  // Sticky listener
  jQuery(document).on('scroll', (e) => {
    // activate/de-activate sticky
    if ((jQuery(window).scrollTop() > stickyTriggerHeight) && !isStickyTablePresent) {
      // if the sticky class is not present sequence some
      // class additions/removals to achieve the sticky's
      // downward fade in effect
      if (!navElement.hasClass('nav-sticky')) {
        navElement.addClass('nav-sticky fade-in');
        navElement.hasClass('primary-nav-dark-bg') ? logoThemeHandlers.toggleLogoTheme(false) : logoThemeHandlers.toggleLogoTheme(true);
        if (navElement.hasClass('has-secondary')) {
          jQuery('header').addClass('sticky-active-secondary');
          if (jQuery('.nav-opaque-bg').hasClass('nav-sticky')) {
            jQuery('header').css('height', stickyTriggerHeight);
          }
        } else {
          const $header = $('header');
          if (jQuery('html, body').is(':animated')) {
            jQuery('html, body').on('transitionend', () => {
              if ($header[0].getBoundingClientRect().y !== 0) {
                $header.addClass('sticky-active');
              }
            });
          } else {
            if ($header[0].getBoundingClientRect().y !== 0) {
              $header.addClass('sticky-active');
            }
          }
        }

        window.setTimeout(() => {
          navElement.removeClass('fade-in');
        }, 300);
      } else if (navElement.hasClass('has-secondary') && !scrollLock && !stickyLock) {
        ResponsiveUtilities.onDeviceType('mobile', function () {
          scrollLock = true;

          window.setTimeout(() => {
            // show/hide primary nav based on scroll direction
            currentScrollPosition = jQuery(window).scrollTop();

            if (!navElement.hasClass('scroll-up') && navElement.hasClass('nav-sticky') && currentScrollPosition < lastScrollPosition) {
              navElement.addClass('scroll-up');
            } else if (navElement.hasClass('nav-sticky') && navElement.hasClass('scroll-up') && currentScrollPosition >= lastScrollPosition) {
              navElement.removeClass('scroll-up');
            }

            lastScrollPosition = currentScrollPosition;
            scrollLock = false;
          }, 100);
        }, {}, e);
      }
    } else if (navElement.hasClass('nav-sticky') && !stickyLock) {
      navElement.removeClass('nav-sticky fade-in');
      jQuery('header').removeClass('sticky-active sticky-active-secondary');
      jQuery('.nav-secondary-buckets > .nav-sub-label').html('');
      jQuery('.nav-secondary-buckets').removeClass('suppressed');
      jQuery('.bucket-link.active, .scroll-link.active').removeClass('active');
      logoThemeHandlers.reset();
      if (jQuery('.nav-opaque-bg').hasClass('has-secondary')) {
        jQuery('header').css('height', '');
      }
      if (jQuery('.bucket-link, .scroll-link').length > 0) {
        menuLineFadeOut();
      }
      ResponsiveUtilities.onDeviceType('mobile', function () {
        navElement.removeClass('scroll-up');
      }, {}, e);
    }
  });

  // Sub-menu dismisser listener
  jQuery('body').on('click', function (e) {
    if (jQuery(e.target).parents('.sub-menu-opened').length === 0) {
      jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
    }
  });

  jQuery('.has-sub-menu:not(.nav-secondary-item)').on('mouseenter', function (e) {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      const hasClassSubmenuOpened = jQuery('.has-sub-menu').hasClass('sub-menu-opened');
      if (!hasClassSubmenuOpened) {
        jQuery('.has-sub-menu:not(.nav-secondary-item) .nav-sub-label, .sub-menu-opened .nav-sub-menu .bottom-pane a, .sub-menu-opened .nav-main-item-list a, .sub-menu-opened .nav-sub-item-link a, .sub-menu-opened .navigation-language-selector .nav-sub-label').attr('tabindex', -1);
      }
    });
  });

  // nav menu should close on hitting escape key
  jQuery(document).on('keyup', function (e) {
    ResponsiveUtilities.onDeviceType('desktop', function () {
      if (e.key === 'Escape' && jQuery('.has-sub-menu').hasClass('sub-menu-opened')) {
        jQuery('.sub-menu-opened .nav-sub-label, .sub-menu-opened .nav-sub-menu .bottom-pane a, .sub-menu-opened .nav-main-item-list a, .sub-menu-opened .nav-sub-item-link a, .sub-menu-opened .navigation-language-selector .nav-sub-label').attr('tabindex', -1);
        jQuery('.sub-menu-opened').removeClass('sub-menu-opened');
      }
    });
  });

  jQuery('.nav-secondary-wrapper .has-sub-menu .nav-sub-label').on('click', function (e) {
    ResponsiveUtilities.onDeviceType(['mobile', 'tablet'], function () {
      jQuery('.nav-secondary-item .nav-sub-menu .nav-sub-label').attr('tabindex', -1);
      jQuery('.nav-secondary-item').removeClass('sub-menu-opened');
    });
  });

  embedGoToAccount();
};

const navigation = {
  navLoader,
  burgerIconHandler
};

export { navigation };
